import { TimesHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const DeleteTimeData = (swimTimeId, state, setState) => {
  if (state.isObjLoading !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Deleting...'
    };
    setState(newState);

    const swimTimeIdForUrl = swimTimeId ? encodeURIComponent(swimTimeId) : 'NaN';
    const url = `/Time/${swimTimeIdForUrl}`;
    TimesHttpHelper(url, 'DELETE')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isSaving: false,
            isSaved: true,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default DeleteTimeData;